<template>
    <v-app id="updHsva">
        <defNavBar title="Ares - Frequently asked questions and answers" :home="true"/>

        <v-main v-if="this.ready === true"> 
            <v-card class="ma-2">
                <span class="px-2">Accomdation: {{huis.huis_code}} </span>
            </v-card>
            <v-container fluid>
                <v-btn class="primary ma-2" x-small @click="addHsva()">Add Q&A</v-btn>
                <ul v-for="(hsvaRecord,i) in huis.hsva" :key="i">
                    <li @click="updHsva(hsvaRecord.hsva_encrid)">
                        {{hsvaRecord.hsvataal_vraag}}
                        <br>
                        {{hsvaRecord.hsvataal_antwoord}}
                    </li>
                    <br>
                </ul> 
                <addHsva ref="addHsva" @reload="loadPage"></addHsva>
                <updHsva ref="updHsva" @reload="loadPage"></updHsva>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
    import addHsva from "@/views/huis/hsva/addHsva.vue";
    import updHsva from "@/views/huis/hsva/updHsva.vue";
    import defNavBar from '@/components/ui/navbars/navbar.vue';
    
    export default {
        components: {
            addHsva,
            updHsva,
            defNavBar
        },
        props: ['huis_encrid'],
        data() {
            return {
                ready: false,
                huis: {
                    action_items: []  /* moet pre defined ivm length check */
                }
            }
        },
        mounted() {
            this.loadPage();
        },
        methods: {
            addHsva() {
                this.$refs.addHsva.open(this.huis_encrid);
            },
            loadPage() {
                this.ready = false;
                this.$axios.post("ares/json/ares/huis/hsva/showHsva.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "showHsva"
                    },
                    showHsva: {
                        huis_encrid: this.huis_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.huis = res.data.showHsva;
                        this.ready = true;
                    }
                });
            },
            updHsva(hsva_encrid) {
                this.$refs.updHsva.open(hsva_encrid);
            }
        }
    };

</script> 
